import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "export",
  "use": "export-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"export\"><defs><style>#export .cls-1{fill:none}</style></defs><title>资源 58</title><g id=\"export_图层_2\" data-name=\"图层 2\"><g id=\"export_图层_1-2\" data-name=\"图层 1\"><path id=\"export_Rectangle_48_Copy_2\" data-name=\"Rectangle 48 Copy 2\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"export_download\"><path id=\"export_Shape\" d=\"M3 22.5A1.46 1.46 0 0 1 1.5 21v-5.18a.81.81 0 0 1 1.62-.06v4.64a.48.48 0 0 0 .48.48h16.8a.47.47 0 0 0 .48-.48v-4.58a.81.81 0 1 1 1.62 0v5.23a1.45 1.45 0 0 1-1.45 1.45H3zm8.49-4.12L7.8 14.73A.81.81 0 0 1 9 13.58l2.27 2.27V2.31a.81.81 0 0 1 1.62 0v13.54l2.27-2.27a.81.81 0 0 1 1.15 1.15l-3.71 3.65a.81.81 0 0 1-1.15 0z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/export.svg
// module id = uPuA
// module chunks = 6